import { BlocksIconSave } from 'blocks-nextjs/blocks-web-components/components/icon/icons/save';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconSave = createComponent({ react: React, tagName: 'cat-icon-save', elementClass: BlocksIconSave });
